<div class="image-viewer-container">
    <div (click)="dialogRef.close()" class="close-viewer">
        <i class="fas fa-times"></i>
    </div>
    @if (showNavigation && currentIndex > 0) {
        <div class="nav-button nav-button-prev" (click)="prevSlide(); $event.stopPropagation()" tabindex="-1">
            <i class="fas fa-chevron-left"></i>
        </div>
    }
    @if (showNavigation && currentIndex < allImages.length - 1) {
        <div class="nav-button nav-button-next" (click)="nextSlide(); $event.stopPropagation()" tabindex="-1">
            <i class="fas fa-chevron-right"></i>
        </div>
    }

    <div class="carousel-container">
        @if (allImages[currentIndex]) {
            <div class="image-slide">
                <div class="image-box">
                    @if (allImages[currentIndex]?.id) {
                        <!-- Document images -->
                        <img
                            src="{{ environment.apiEndpoint }}documents/download/{{
                                allImages[currentIndex].id
                            }}?access_token={{ LocalStorage.getUserToken() }}"
                            class="img"
                            alt="image" />
                    } @else if (allImages[currentIndex]?.path) {
                        <!-- Regular images with path -->
                        <img
                            class="img"
                            alt="image"
                            src="{{ environment.apiEndpoint }}file/thumb?{{ secure }}path=/{{
                                allImages[currentIndex].timeline_id || allImages[currentIndex].news_id
                            }}/{{ allImages[currentIndex].path }}&access_token={{ LocalStorage.getUserToken() }}" />
                    } @else {
                        <!-- Direct image URLs -->
                        <img [src]="allImages[currentIndex]" class="img" alt="image" />
                    }
                </div>
                @if (allImages[currentIndex]?.id) {
                    <div class="text">
                        {{ allImages[currentIndex].name }}<br />
                        @if (allImages[currentIndex].updated_at) {
                            {{ allImages[currentIndex].updated_at | date: 'd MMM yyyy, H:mm' }}
                        } @else {
                            Zojuist gemaakt
                        }
                    </div>
                }
            </div>
        }
    </div>

    <!-- Image counter -->
    @if (allImages.length > 1) {
        <div class="image-counter">{{ currentIndex + 1 }} / {{ allImages.length }}</div>
    }
</div>
